import { render, staticRenderFns } from "./LocalEpie.vue?vue&type=template&id=1532a721&scoped=true"
import script from "./LocalEpie.vue?vue&type=script&lang=js"
export * from "./LocalEpie.vue?vue&type=script&lang=js"
import style0 from "./LocalEpie.vue?vue&type=style&index=0&id=1532a721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1532a721",
  null
  
)

export default component.exports